<template>
  <div class="animated fadeIn list-of-opi">
    <b-card v-if="(showForm==false)">
      <div slot="header">Invoicing - Iklan Platform Digital (OPI Digital)
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="edit">Generate Invoice</b-button>
          <b-dropdown text="Print" variant="primary mr-1">
            <b-dropdown-item @click="printInvoice" >Print Invoice</b-dropdown-item>
            <b-dropdown-item @click="print" >Print OPI</b-dropdown-item>
          </b-dropdown>

          <button class="btn btn-primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</button>
          <button class="btn btn-primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</button>
            <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col md="6">
              <b-row>
                <b-col md="6" xl="5">
                    <b-input-group >
                      <b-input-group-prepend><label >Nomor OPI</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.orderno" ></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col md="6"  xl="5">
                    <b-input-group >
                      <b-input-group-prepend><label >Sales Order No.</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.mediaorder" ></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>  
              <b-input-group >
                <b-input-group-prepend><label>Pemasang</label></b-input-group-prepend>
                <b-form-input v-model="tblData.pemasang" @change="tblData.customer_id=''" placeholder="Perushaan Biro Iklan/Perorangan"></b-form-input>
                <b-input-group-append>
                  <b-btn variant="primary" text="Button" @click="lkuCustomerShow=true" >
                      <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
                <b-form-input v-model="tblData.Advertiser" placeholder="Advertiser" class="ml-1"></b-form-input>
              </b-input-group>     
              <b-input-group>
                <b-input-group-prepend><label>Sales Executive</label></b-input-group-prepend>
                <b-form-input v-model="tblData.sales_search"></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuSalesShow=true" variant="primary"><i class="fa fa-search"></i></b-btn>
                </b-input-group-append>
                <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Judul Iklan</span></b-input-group-prepend>
                <b-form-input v-model="tblData.juduliklan"></b-form-input>
              </b-input-group>

        </b-col>
        <b-col md="6" xl=5>
              <b-row>
                <b-col md="12" xl="10">
                  <b-input-group >
                    <!-- <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Tgl. OPI</span></b-input-group-prepend> -->
                      <b-input-group-prepend><label >Tanggal OPI</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">s.d</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>  
              <b-input-group >
                <b-input-group-prepend><label >Telah diinvoice</label></b-input-group-prepend>
                  <b-form-select v-model="tblData.isinvoiced" :plain="true" :options="YesNoAll"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">Billing Term</span></b-input-group-prepend>
                <b-form-select v-model="tblData.billing" :plain="true" :options="invoicingTerms"></b-form-select>
              </b-input-group>
            <b-input-group>
                <b-input-group-prepend><label>Bentuk Bayar</label></b-input-group-prepend>
                  <b-form-select v-model="tblData.jenisbayar" :plain="true" :options="paymentFormFilt"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">Komplit</span></b-input-group-prepend>
                  <b-form-select v-model="tblData.completed" :plain="true" :options="YesNoAll"></b-form-select>
                <b-input-group-append>
                      <b-button variant="success" size="sm" @click="search()" class="ml-2"> <i class="fa fa-refresh"></i> Apply Filter</b-button>                
                </b-input-group-append>
                <b-input-group-append>
                      <b-button variant="secondary" size="sm" class="ml-1" @click="clearFilter()" >Clear</b-button>
                </b-input-group-append>
              </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#"  style="padding:0 !important;">Generate Invoice</b-dropdown-item>
          <b-dropdown-item @click="rowPrintInvoice(data.item)" href="#" style="padding:0 !important;">Print Invoice</b-dropdown-item>
          <b-dropdown-item @click="rowPrint(data.item)" href="#" style="padding:0 !important;">Print OPI </b-dropdown-item>
        </b-dropdown>
      </template>          
        <template v-slot:cell(orderdate)="data">
          {{ data.item.orderdate | moment("DD MMM YYYY") }}
        </template>

        <template v-slot:cell(total)="data">
          {{data.item.total | numFormat}}
        </template>
        <template v-slot:cell(jiklan)="data">
          {{data.item.jiklan}} <span v-if="data.item.baris==0"> ({{data.item.jwarna}}) </span>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>        
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page"  style="margin-top:0 !important;">
            <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>


    <b-card v-if="(showForm==true)">
        <div slot="header">
            AR Invoice Form
            <div class="card-header-actions">
            <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
              <button class="btn btn-danger mr-1" @click="showForm=false" > <i class="fa fa-close"></i> Close</button>
            </div>
        </div>
          <b-row>
            <b-col lg="8">
                <b-form-row>
                    <b-col lg="5">
                    <b-input-group>
                        <b-input-group-prepend><label>Invoice Number</label></b-input-group-prepend>
                        <b-form-input v-model="model.invoiceno" v-b-tooltip.hover title="EMPTY for AUTO NUMBERING"></b-form-input>
                    </b-input-group>
                    </b-col>
                    <b-col lg="7">                            
                    <b-input-group>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Invoice Date</span></b-input-group-prepend>
                        <b-form-input v-model="model.invdate" type="date" :state="!$v.model.invdate.$error"></b-form-input>                                        
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Due</span></b-input-group-prepend>
                        <b-form-input v-model="model.invdueda" type="date"></b-form-input>                                        
                    </b-input-group>
                    </b-col>
                </b-form-row >                      
                <b-input-group >
                    <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
                    <b-form-input readonly v-model="model.custinfo" :state="!$v.model.custcode.$error" style="width:50% !important;"></b-form-input>
                    <b-input-group-prepend><span class="p-2">Attention</span></b-input-group-prepend>
                    <b-form-input v-model="model.ContactFin" placeholder="u.p." ></b-form-input>                                        
                </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label>Description </label></b-input-group-prepend>
                    <b-form-input v-model="model.uraian1" :state="!$v.model.uraian1.$error" placeholder="line#1"></b-form-input>
                    <b-form-input v-model="model.uraian2" placeholder="line#2"></b-form-input>
                </b-input-group>
                <!-- <b-form-row>
                    <b-col cols="6" >
                        <b-input-group >
                            <b-input-group-prepend><label>Invoice Amount</label></b-input-group-prepend>
                            <b-input-group-prepend>
                            <b-form-select class="input-group-text" v-model="model.matauang" :plain="true" :options="currency" :state="!$v.model.matauang.$error"></b-form-select>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" separator="," v-model="model.totalinv" :precision="2" :state="!$v.model.totalinv.$error"></my-number>
                        </b-input-group>
                    </b-col>
                    <b-col cols="6">   
                            <b-form-radio-group class="ml-2 mt-2" v-model="model.deffered" >
                                <b-form-radio value="0">Invoice Actual</b-form-radio>
                                <b-form-radio value="1">Unearned Income</b-form-radio>
                            </b-form-radio-group>
                    </b-col>
                </b-form-row> -->
            </b-col>
            <b-col lg="4">
                <b-input-group>
                    <b-input-group-prepend><label>Sales / AE</label></b-input-group-prepend>
            <b-form-input v-model="tblData.salesae_name" placeholder="Sales (AE)" @change="tblData.salesid_id=''"></b-form-input>
                    <b-input-group-append>
                    <b-btn variant="primary" text="Button" @click="lkuSalesShow=true" >
                        <i class="fa fa-search"></i>
                    </b-btn>
                    </b-input-group-append>
                </b-input-group>
                <!-- <v-dim :model="model" :key="updateDimHdr" ></v-dim> -->
                <b-input-group >
                    <b-input-group-prepend><label>Cash Flow</label></b-input-group-prepend>
                    <b-form-input readonly v-model="model.cashflow" @keyup.13.native="showLkuCashflow('model')" ></b-form-input>
                    <b-input-group-append>
                    <b-btn text="Button" @click="showLkuCashflow('model')" id="apKodecash">
                        <i class="fa fa-search"></i>
                    </b-btn>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
          </b-row>
          <b-card no-body class="mb-1">
            <b-table
                class="mb-0"
                ref="tblArLines"
                outlined striped hover small
                style="font-size:smaller;" 
                :items="arLines.items"
                :fields="arLines.fields"
                :current-page="arLines.page"
                :per-page="arLines.limit"
                >
                    <template v-slot:cell(index)="data">
                    {{data.index + 1}}
                    </template>
                    <template v-slot:cell(description)="data">
                        <pre>{{data.item.description}}</pre>
                    </template>
                    <template v-slot:cell(quantity)="data">
                        {{data.item.quantity}} {{data.item.unitsize}}
                    </template>
                    <template v-slot:cell(unitprice)="data">
                    {{data.item.unitprice|numFormat('0,0.00')}}
                    </template>
                    <template v-slot:cell(nilai)="data">
                    {{data.item.nilai|numFormat('0,0.00')}}
                    </template>
                    <template v-slot:cell(nilaippn)="data">
                    {{data.item.nilaippn|numFormat('0,0.00')}}
                    </template>
                    <template v-slot:cell(nilaidue)="data">
                    {{data.item.nilaidue|numFormat('0,0.00')}}
                    </template>
                    <template v-slot:cell(action)="data">
                        <div class="text-center">
                        <a href="javascript:void(0)" @click="editArLines(data.item,data.toggleDetails)">
                            <i class="fa fa-pencil"></i>
                        </a>
                        |
                        <a href="javascript:void(0)" class="text-danger" @click="delArLines(data.index)">
                            <i class="fa fa-trash"></i>
                        </a>
                        </div>
                    </template>
                <template v-slot:row-details="row">
                <b-card class="row-details-form">
                    <!-- <b-tabs card v-model="tabIndex">
                        <b-tab title="INVOICE ITEM DETAIL" active> -->
                            <b-row h-align="center">
                                <b-col lg="6" class="pl-0">
                                    <b-input-group>
                                        <b-input-group-prepend><label>Revenue Account</label></b-input-group-prepend>
                                        <b-form-select v-model="arLinesObj.salesKode" :plain="true" :options="salesAccounts" :state="!$v.arLinesObj.salesKode.$error"></b-form-select>
                                    </b-input-group>
                                    <b-input-group>
                                        <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                                        <b-form-textarea :rows="4" :max-rows="13" v-model="arLinesObj.description" :state="!$v.arLinesObj.description.$error" ></b-form-textarea>
                                    </b-input-group>
                                    <b-form-row>
                                    <b-col md="6">                            
                                        <b-input-group>
                                            <b-input-group-prepend><label>Quantity</label></b-input-group-prepend>
                                            <b-form-input v-model="arLinesObj.quantity" @change="calcPrice()" type="number" :state="!$v.arLinesObj.quantity.$error"></b-form-input>
                                        </b-input-group>
                                    </b-col>
                                    <b-col md="6">                            
                                        <b-input-group>
                                            <b-input-group-prepend><label style="width:70px; text-align:right;">Unit Size</label></b-input-group-prepend>
                                            <b-form-input v-model="arLinesObj.unitsize" ></b-form-input>
                                        </b-input-group>
                                    </b-col>
                                    </b-form-row > 
                                    <b-form-row>
                                    <b-col md="8">                            
                                        <b-input-group>
                                            <b-input-group-prepend><label>Unit price</label></b-input-group-prepend>
                                            <b-input-group-prepend>
                                            <span class="input-group-text">{{model.matauang}}</span>
                                            </b-input-group-prepend>
                                            <my-number class="form-control text-right" v-model="arLinesObj.unitprice" :precision="2" :state="!$v.arLinesObj.unitprice.$error"></my-number>
                                        </b-input-group>
                                    </b-col>
                                    <b-col md="4">
                                        <b-input-group>
                                            <b-input-group-prepend><label >Discount</label></b-input-group-prepend>
                                            <b-form-input v-model="arLinesObj.disc" ></b-form-input>
                                            <b-input-group-append><span class="input-group-text"> %</span></b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                    </b-form-row >                      

                                </b-col>
                                <b-col lg="6" class="pl-0"> 
                                    <b-form-row>
                                        <b-col xl="10">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label>Amount</label></b-input-group-prepend>
                                                <b-input-group-prepend>
                                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                                </b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="arLinesObj.nilai" :precision="2" disabled></my-number>
                                            </b-input-group>
                                            <b-input-group>
                                                <b-input-group-prepend><label>Discount</label></b-input-group-prepend>
                                                <b-input-group-prepend>
                                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                                </b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="arLinesObj.nilaidisc" :precision="2" ></my-number>
                                            </b-input-group>
                                        </b-col>
                                    </b-form-row >                      
                                    <b-form-row>
                                        <b-col xl="10">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label>Net Amount</label></b-input-group-prepend>
                                                <b-input-group-prepend>
                                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                                </b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="arLinesObj.nilainett" :precision="2" disabled></my-number>
                                            </b-input-group>
                                        </b-col>
                                        <b-col xl="2">                            
                                            <b-form-checkbox id="chkPPN" class="ml-1 mt-2 text-left" v-model="arLinesObj.kenappn" value=1 unchecked-value=0 @change="calcTaxes()" :state="!$v.arLinesObj.kenappn.$error">PPN(VAT)</b-form-checkbox>
                                        </b-col>
                                    </b-form-row >                      

                                    <b-form-row v-if="(arLinesObj.kenappn==1)">
                                        <b-col xl="6">
                                            <b-input-group>
                                                <b-input-group-prepend><label>Tarif DPP</label></b-input-group-prepend>
                                                <b-form-input v-model="arLinesObj.dppnlain" @change="calcTaxes()"></b-form-input>
                                                <b-input-group-append><span class="input-group-text">% </span></b-input-group-append>
                                                <b-input-group-append><span class="pt-2"><strong> &nbsp; * Net Amount</strong> </span></b-input-group-append>
                                            </b-input-group>
                                        </b-col>
                                        <b-col xl="4">                            
                                            <b-input-group>
                                                <b-input-group-prepend><span class="p-2">Tarif PPN</span></b-input-group-prepend>
                                                <b-form-input v-model="arLinesObj.ppn" @change="calcTaxes()" type="number" v-b-tooltip.hover :title="arLinesObj.ppn"></b-form-input>
                                                <b-input-group-append><span class="input-group-text">%</span></b-input-group-append>
                                            </b-input-group>
                                        </b-col>
                                    </b-form-row >         
                                    <b-form-row>
                                        <b-col xl="10">                            
                                            <b-row no-gutters>
                                                <b-col cols="8">
                                                    <b-input-group>
                                                        <b-input-group-prepend><label>PPH akan dipotong</label></b-input-group-prepend>
                                                        <b-form-select v-model="arLinesObj.pasalpph" :plain="true" :options="lookupPPH" ></b-form-select>
                                                    </b-input-group>                                          
                                                </b-col>
                                                <b-col cols="4">
                                                    <b-input-group>
                                                        <b-input-group-prepend><span class="p-2">Tarif PPH</span></b-input-group-prepend>
                                                        <b-form-input v-model="arLinesObj.pph" type="number" v-b-tooltip.hover :title="arLinesObj.pph"></b-form-input>
                                                        <!-- <my-number v-model="arLinesObj.pph" :precision="2" v-b-tooltip.hover :title="arLinesObj.pph"></my-number> -->
                                                        <b-input-group-append><span class="input-group-text">%</span></b-input-group-append>
                                                    </b-input-group>
                                                </b-col>
                                            </b-row>
                                            <b-row no-gutters>
                                                <b-col cols="1">&nbsp;
                                                </b-col>
                                                <b-col cols="4">
                                                    <b-input-group>
                                                        <b-form-select style="font-size:0.78rem !important;width:158px;"  v-model="calcPPh" :plain="true" :options="calcuationPPH" ></b-form-select>
                                                    </b-input-group>
                                                </b-col>
                                                <b-col cols="7">
                                                    <b-input-group>
                                                        <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                                                        <my-number class="form-control text-right" v-model="arLinesObj.nilaipph" :precision="2" :readonly="(calcPPh===1)"></my-number>
                                                    </b-input-group>                                          
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </b-form-row >         

                                </b-col>
                            </b-row>
                        <!-- </b-tab>
                        <b-tab title="INVOICE ITEM DIMENSION">
                            <b-row>
                                <b-col lg="8" xl="6"  class="pl-0">
                                    <v-dim :model="arLinesObj" :key="updateDimDtl"></v-dim>
                                </b-col>
                            </b-row>
                        </b-tab>
                    </b-tabs> -->
                    <b-row class="justify-content-center mt-1">
                        <div style="width:400px;">
                            <b-input-group >
                                <!-- <b-input-group-prepend><span class="p-2">Add Line after update</span></b-input-group-prepend>
                                <b-form-checkbox v-model="inputLineBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox> -->
                                <b-input-group-append>
                                    <b-button class="btn btn-success mr-1" @click="saveArLines()">Update</b-button>
                                </b-input-group-append>
                                <b-input-group-append>
                                    <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </div>
                    </b-row>
                </b-card>
                </template>                        
            </b-table>
            <b-row class="mt-1">
                <b-col cols="5">
                    <b-row>
                        <b-button size="sm" class="ml-3" @click="addArLines" >Add Detail</b-button>                          
                        <div class="ml-2">
                            Showing {{((arLines.page - 1) * arLines.limit + 1)}}
                            to <span v-if="((arLines.page * arLines.limit)>arLines.total)">{{arLines.total}}</span>
                                <span v-else>{{arLines.page * arLines.limit}}</span>
                            <strong> of {{arLines.total}} entries </strong>
                        </div>    
                    </b-row>                    
                </b-col>
                <b-col cols="2">
                        <b-input-group>
                            <b-input-group-prepend><span class="ml-4 pt-1 mr-2">Limit per page</span></b-input-group-prepend>
                            <b-form-select :options="[5, 10, 15, 20, 25]" :plain="true" v-model="arLines.limit"  style="width:80px;"/>
                        </b-input-group>
                </b-col>
                <b-col cols="5">
                    <b-pagination
                        align="right"
                        :total-rows="arLines.total"
                        :per-page="arLines.limit"
                        v-model="arLines.page"
                    ></b-pagination>
                </b-col>
            </b-row>
          </b-card>    
            <b-row align-h="between" class="mt-1">
                <b-col lg="8" xl="7">
                    <b-form-row>
                        <b-col lg="6">
                            <b-input-group>
                                <b-input-group-prepend><label>AR Post Group</label></b-input-group-prepend>
                                <b-form-select v-model="model.artype" :plain="true" :options="postGroups" :state="!$v.model.artype.$error"></b-form-select>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">
                            <b-form-radio-group class="ml-2 mt-2" v-model="model.deffered" >
                                <b-form-radio value="0">Invoice Actual</b-form-radio>
                                <b-form-radio value="1">Unearned Income</b-form-radio>
                            </b-form-radio-group>
                        </b-col>
                    </b-form-row>                      
                    <b-form-row>
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label>No. Faktur Pajak</label></b-input-group-prepend>
                                <b-form-input v-model="model.nofaktur"  v-b-tooltip.hover title="Jika dikosongkan, Sistem akan isi otomatis" placeholder="Kosongkan, u/ pengisian otomatis"></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col xl="5" lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label >Tgl. Faktur Pajak</label></b-input-group-prepend>
                                <b-form-input v-model="model.tglfaktur" type="date"></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-form-row>                      
                    <b-row v-if="(model.matauang !== uanguser)">
                        <b-col lg="6">
                        <b-input-group >
                            <b-input-group-prepend><label >Exch. Rate <strong>{{model.matauang}}</strong></label></b-input-group-prepend>
                            <b-input-group-prepend>
                            <span class="input-group-text" style="width:60px;">{{uanguser}}</span>
                            </b-input-group-prepend>
                            <my-number  class="form-control text-right" separator="," v-model="model.kursPPN" :state="!$v.model.kursPPN.$error"></my-number>
                        </b-input-group>
                        </b-col>
                        <b-col lg="6">
                        <b-input-group >
                            <b-input-group-prepend><label style="text-align: right !important;">Kurs Pajak <strong>{{model.matauang}}</strong></label></b-input-group-prepend>
                            <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{uanguser}}</span></b-input-group-prepend>
                                <my-number class="form-control text-right" separator="," v-model="model.kursPPN"  :state="!$v.model.kursPPN.$error"></my-number>
                            </b-input-group>
                        </b-col>
                    </b-row>                      
                    <b-row>
                        <b-col lg="7">
                            <b-input-group >
                                <b-input-group-prepend><label>PPH akan dipotong</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.totalpph" :precision="2" disabled></my-number>
                                <b-form-checkbox id="chkGrossUp" class="ml-1 mt-2" v-model="model.grossup" value=1 unchecked-value=0>Gross Up</b-form-checkbox>
                            </b-input-group>
                        </b-col>
                        <b-col lg="5">
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: left;width:158px; padding-left:16px;">Bentuk Pembayaran</label></b-input-group-prepend>
                                <b-form-select v-model="model.pack_name" :plain="true" :options="paymentForms" v-b-tooltip.hover :title="model.pack_name">
                                </b-form-select>
                            </b-input-group>
                        </b-col>
                    </b-row>   
                    <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-1">Payment should transfer to Bank Account</span></b-input-group-prepend>
                        <b-form-input readonly v-model="model.namabank2" @keyup.13.native="lkuBankaccountShow=true" :state="!$v.model.kodebank.$error" style="width:16% !important;"></b-form-input>
                        <b-input-group-append>
                            <b-btn text="Button" @click="lkuBankaccountShow=true">
                                <i class="fa fa-search"></i>
                            </b-btn>
                        </b-input-group-append>
                        <b-input-group-prepend><span class="ml-1 pt-2 mr-1">Acc.No.</span></b-input-group-prepend>
                        <b-form-input disabled v-model="model.nomorrek"></b-form-input>
                        <b-input-group-append>
                            <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                        </b-input-group-append>
                    </b-input-group>
                    <!-- <div class="text-right mt-3">
                        <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                        <button class="btn btn-primary" @click="close()" > <i class="fa fa-close"></i> Close</button>
                    </div> -->

                    <b-row class="justify-content-center mb-2">
                        <div style="width:450px;" class="text-right">
                            <b-input-group >
                                <!-- <b-input-group-prepend><span class="p-2">remain on Form after save</span></b-input-group-prepend>
                                <b-form-checkbox v-model="inputBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox> -->
                                <b-input-group-append>
                                    <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                                </b-input-group-append>
                                <b-input-group-append>
                                    <button class="btn btn-danger mr-1" @click="showForm=false" > <i class="fa fa-close"></i> Close</button>
                                </b-input-group-append>
                            </b-input-group>
                        </div>
                    </b-row>
                </b-col>
                <b-col lg="4">
                    <div class="text-right">
                        <b-input-group >
                            <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">Gross</label></b-input-group-prepend>
                            <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttlgross" :precision="2" disabled></my-number>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend>
                            <b-form-select style="width:158px;"  v-model="model.calcDisc" :plain="true" :options="calcuationDisc" ></b-form-select>
                            </b-input-group-prepend>
                            <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttldiskon" :precision="2" :readonly="(model.calcDisc===1)"></my-number>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">Netto</label></b-input-group-prepend>
                            <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttlnetto" :precision="2" disabled></my-number>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend>
                            <b-form-select style="width:158px;"  v-model="model.calcVAT" :plain="true" :options="calcuationVAT" ></b-form-select>
                            </b-input-group-prepend>
                            <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttlvat" :precision="2" :readonly="(model.calcVAT===1)"></my-number>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label style="text-align: left;width:158px; padding-left:16px;">Total Amount Due</label></b-input-group-prepend>
                            <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttlamtdue" :precision="2" disabled></my-number>
                        </b-input-group>
                    </div>
                </b-col>
            </b-row>
    </b-card>


    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>

        <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true" :lazy="true">
            <lku-customer @click="onSelectLkuCustomer"></lku-customer>
        </b-modal>   
        <b-modal v-model="lkuCashflowShow" size="lg" :hide-footer="true" title="List of Cashflow Account" :centered="true">
                <lku-cashflow @click="onSelectLkuCashflow" :formdata="lkuCashflowData"></lku-cashflow>
        </b-modal>      
        <b-modal v-model="lkuBankaccountShow" size="lg" :hide-footer="true" title="List of Bank/Cash Account" :centered="true">
            <lku-bankaccount @click="onSelectLkuBankaccount" isbank="1" :formdata="lkuBankaccountData" aktif="1" ></lku-bankaccount>
        </b-modal>        
    <b-modal v-model="lkuSalesShow" size="lg" :hide-footer="true" title="List of Sales Ex." :centered="true">
      <lku-salesae @click="onSelectsales"></lku-salesae>
    </b-modal>

  </div>
</template>

<style lang="scss">
  .list-of-opi {
      table {
        td:nth-child(1) {
          width: auto;
        }
        td:nth-child(2) {
          width: auto;
        }
        td {
          .dropdown-item {
              padding: 0.1rem 1.5rem !important;
              font-size: smaller !important;
          }    
        }
      }
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 100px;
            }
        }
    }
}
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import opi from "../../apis/koran_opidigital";
import arinv from "../../apis/arinv";
import myNumber from "../../components/my-number";
import lkuBankaccount from "../lookup/lkuBankaccountLazzy";
import lkuCashflow from "../lookup/lkuCashflowLazzy";
import lkuCustomer from "../lookup/lkuCustomer";
import lkuSalesae from "../lookup/lkuSalesae";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required, decimal} from "vuelidate/lib/validators";
toastr.init();

export default {
  components: {myNumber,Loading,lkuBankaccount, lkuCustomer, lkuCashflow, lkuSalesae },
  mixins: [validationMixin],
  validations: {
        model: {
            custcode: { required },
            uraian1: { required },
            invdate: { required },
            artype: { required },
            kodebank: { required },
            // kodecash: { required },
            matauang: { required },
            totalinv: { required },
            // kursPPN: { numeric, required:requiredUnless('localCurrency') }
            kursPPN: {required : (function() {
                if ((this.model.ttlvat || 0) == 0) {
                    this.model.kursPPN=this.model.kursPPN || 1;
                    return true;
                } else if (this.model.matauang == this.uanguser){
                    this.model.kursPPN=1;
                    return true;
                } else if ((this.model.kursPPN || 0) == 0){
                    return false;
                } else return true;
            })},
        },
        arLinesObj: {
            salesKode: { required },
            description: { required },
            quantity: { decimal },
            unitprice: { decimal },
            nilai: { decimal },
            ppn: { decimal },
            kenappn: { required },
            pph: { decimal },
        },
  }, 
  data() {
    return {
      showFilter: false,
      showForm: false,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      tblData: {
        status:"",
        postgroup:"",
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        billb4comp: 0,
        sortBy: null,
        sortDesc: false
      },
      tblFields:[
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
          {
            key: "orderno",
            label: "Order No",
            sortable: true
          },
          {
            key: "orderdate",
            label: "Date",
            sortable: true,
            thStyle: "width:90px",
            thClass: "text-center",
          },
          {
            key: "CustName",
            label: "Pemasang",
            sortable: true
          },
          {
            key: "Advertiser",
            label: "Advertiser",
            sortable: true
          },
          {
            key: "juduliklan",
            label: "Judul Iklan",
          },
          {
            key: "jiklan",
            label: "Jenis Iklan",
            sortable: true
          },
          {
            key: "ukuraniklan",
            label: "Ukuran",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "posisirubrik",
            label: "Posisi",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "jmlmuat",
            label: "Freq. Muat",
            thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "total",
            label: "Amount",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "realmuat",
            label: "Realisasi Muat",
            thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "invoiceno",
            label: "NO.INVOICE",
            thClass: "text-center",
            tdClass: "text-center",
            variant: "success",
            sortable: true
          },
          {
            key: "SalesEx",
            label: "Sales Ex.",
            thStyle: "width:110px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "mediaorder",
            label: "Sales Order",
            thStyle: "width:110px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "jenisbayar",
            label: "Bentuk Bayar",
            thStyle: "width:110px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
      ],      
      invoicingTerms:[
          {value:'DI AWAL', text: 'DI AWAL'},
          {value:'PER TERMIN', text: 'PER TERMIN'},
            {value:'PER TAYANG', text: 'PER TAYANG'},
            {value:'PER BULAN', text: 'PER BULAN'},
            {value:'DI AKHIR', text: 'DI AKHIR'},
            {value:'', text: '--semua--'}],
      YesNoAll :   [{ value: 1, text: 'YES' }, { value: 0, text: 'NO' }, { value: '', text: '-ALL-' }],
      paymentFormFilt:[{value:'STANDARD', text: 'Standard Cash/Bank'}],
      terpilih:{},

        saveEnabled:true,
        inputBerlanjut: 0,
        inputLineBerlanjut: 1,
        lkuCashflowData:{},
        lkuCashflowShow: false,
        lkuCashflowCaller:'model',        
        lkuCustomerShow: false,
        lkuBankaccountData:{},
        lkuBankaccountShow: false,
        lkuSalesShow: false,
        uanguser: this.$store.state.user.matauang,
        postGroups:[],salesAccounts:[],bankAccount:[],
        currency:[{value:'IDR',text:'IDR'}],
        calcuationVAT : [{ value: 1, text: 'VAT (Auto Calc)' }, { value: 0, text: 'VAT (Manual Calc)' }],
        calcuationDisc : [{ value: 1, text: 'Disc (Auto Calc)' }, { value: 0, text: 'Disc (Manual Calc)' }],
        calcPPh:1,
        calcuationPPH : [{ value: 1, text: 'Nilai PPH(Auto)' }, { value: 0, text: 'Nilai PPH(Manual)' }],
        lookupPPH:[], paymentForms:[{value:'STANDARD', text: 'Standard Cash/Bank'}],
        YesNo :   [{ value: 1, text: 'YES' }, { value: 0, text: 'NO' }],
        model:{custcode: '',ordernumber:'',salesReff:'Line/item',
            uraian1: '',
            invdate: moment().format('YYYY-MM-DD'),
            artype: '',
            kodebank: 'MDR IN',
            namabank2: 'BANK MANDIRI',
            nomorrek: '1170002160927',
            kodecash: '',
            matauang: 'IDR',pack_name:'STANDARD',
            nofaktur: '', tglfaktur: '',
            totalinv: 0,
            kursPPN: 1,
            nilaippn:0,ttlvat:0,deffered:0,proforma:0, 
            DimTableKey:'', ttlgross:'', ttlamtdue:'', calcVAT:1,calcDisc:1},
        arLines: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "description",
                    label: "Description",
                },
                {
                    key: "NamaSale",
                    label: "Revenue Account"
                },
                {
                    key: "quantity",
                    label: "Quantity",
                    thStyle: "width:90px",
                },
                {
                    key: "unitprice",
                    label: "Unit price",
                    thStyle: "width:120px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilai",
                    label: "Amount NETT",
                    thStyle: "width:120px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaippn",
                    label: "VAT",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaidue",
                    label: "Amount DUE",
                    thStyle: "width:120px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 5,
            total: 0,
        },
        arLinesObj:{unitsize:'', 
            DimTableKey:'', 
            salesKode: '',
            description: '',
            quantity: 1,
            unitprice: 0,
            nilai: 0,
            ppn: 0,
            kenappn: 0,
            pasalpph: '',
            pph: 0,
            nilaidisc:0,
            disc:0
        },
        tabIndex:0

    };
  },
  computed: {
    invalidArLines() {
      this.$v.arLinesObj.$touch();
      return this.$v.arLinesObj.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    noPPN(){
        return (this.model.nilaippn == 0);
    },
    unitprice(){
        return this.arLinesObj.unitprice;
    },
    pasalpph(){
        return this.arLinesObj.pasalpph;
    },    
    salesKode(){
        return this.arLinesObj.salesKode;
    },    
    tarifPPh(){
        return this.arLinesObj.pph;
    },    
    disc(){
        return this.arLinesObj.disc || 0;
    },    
    discvalue(){
        return this.arLinesObj.nilaidisc;
    },    
    disctotal(){
        return this.model.ttldiskon;
    },    
    vattotal(){
        return this.model.ttlvat;
    },    
  },
  watch: {
    unitprice: function(newval) {
            this.calcPrice();
    },    
    pasalpph: function(newval) {
        const item = this.lookupPPH.find(p => p.value==newval);
        if (item) {
            this.arLinesObj.pph=item.pph;
            setTimeout(() => {
                this.calcTaxes();
            }, 100);
        }
    },    
    tarifPPh: function(newval) {
            this.calcPrice();
    },    
    disc: function(newval) {
        setTimeout(() => {
            this.arLinesObj.nilaidisc = parseFloat((this.arLinesObj.nilai || 0)) * parseFloat(this.arLinesObj.disc) / 100;;        
            this.calcTaxes();            
        }, 500);
    },    
    discvalue: function(newval) {
        setTimeout(() => {
            this.calcTaxes();            
        }, 500);
    },    
    disctotal: function(newval) {
        this.model.ttlnetto=this.model.ttlgross-this.model.ttldiskon;
        this.model.ttlamtdue = this.model.ttlnetto+this.model.ttlvat;
    },    
    vattotal: function(newval) {
        this.model.ttlamtdue = this.model.ttlnetto+this.model.ttlvat;
    },    
    salesKode: function(newval) {
      if (this.salesAccounts) {
        const item = this.salesAccounts.find(p => p.value==newval);
        if (item) {
            this.arLinesObj.NamaSale=item.text;
        }
        if (newval=="N/A") {
            this.arLinesObj.unitsize='';
            this.arLinesObj.quantity = 0;
            this.arLinesObj.kenappn = 0;
            this.arLinesObj.dppnlain = 100;
            this.arLinesObj.ppn = 0;
            this.arLinesObj.nilaipph = 0;
            this.arLinesObj.nilainett =0;
            this.arLinesObj.unitprice=0;
            this.arLinesObj.pasalpph='N/A';
        }

      }
    },    
    noPPN: function(newval) {
        if (newval) {
            this.model.nofaktur='';
            this.model.tglfaktur='';
        }
    },    
  },  
  created: async function(){
        const now = new Date();
        const tgl1 = moment(now).startOf('month').format('YYYY-MM-DD');
        const tgl2 = moment(now).endOf('month').format('YYYY-MM-DD');
        this.tblData.tgl1=this.tblData.tgl1 || tgl1;
        this.tblData.tgl2=this.tblData.tgl2 || tgl2;
        const [a,b,c,d,e,f] = await Promise.all([arinv.postgroup(),arinv.pasalpph(),arinv.currency(),arinv.salesAccount(),arinv.bankacconly(), arinv.paymentform()]) ;
        this.postGroups = a;
        this.lookupPPH = b;
        this.currency = c;
        this.salesAccounts = d;
        this.bankAccount = e;
        this.paymentForms = f;
      this.paymentFormFilt = f.reduce((newArr,item) =>{
          newArr.push(item);
          return newArr;
      },[{ value: '', text: '--- ALL ---'}]);

  },  
  methods: {
    onSelectsales(_selected) {
        if (showForm==false) {
            this.tblData.salesae_id = _selected.salesae_id;
            this.tblData.salesae_name = _selected.salesae_name;

        } else {
            this.model.salesae_id = _selected.salesae_id;
            this.model.accexec.salesae_name = _selected.salesae_name;
        }
      this.lkuSalesShow = false;
    },
    onSelectLkuBankaccount(lkuData) {
        this.lkuBankaccountData=lkuData;
        this.lkuBankaccountShow=false;
        this.model.kodebank=lkuData.selected.kode;
        this.model.matauang=lkuData.selected.matauang;
        this.model.namabank=lkuData.selected.namabank;
        this.model.namabank2=lkuData.selected.namabank2 || lkuData.selected.namabank;
        this.model.nomorrek=lkuData.selected.nomorrek;
        // this.model.isbank=lkuData.selected.isbank;
        this.lkuBankaccountShow=false;
    },
    showLkuCashflow(callerObj) {
        this.lkuCashflowShow=true;
        this.lkuCashflowCaller=callerObj;
    },
    onSelectLkuCashflow(lkuData) {
        this.lkuCashflowData=lkuData;
        this.lkuCashflowShow=false;
        this[this.lkuCashflowCaller].cashflow = lkuData.selected.kodecash.trim() + ' | ' + lkuData.selected.namacash.trim();
        this[this.lkuCashflowCaller].kodecash = lkuData.selected.kodecash;
        this[this.lkuCashflowCaller].namacash = lkuData.selected.namacash;
        if ((this.model.cashflow || '') == '') {
            this.model.cashflow = lkuData.selected.kodecash.trim() + ' | ' + lkuData.selected.namacash.trim();
            this.model.kodecash = lkuData.selected.kodecash;
            this.model.namacash = lkuData.selected.namacash;
        }
        this.lkuCashflowShow=false;
    },
    calcPrice : function() {
        this.arLinesObj.nilai = parseFloat(this.arLinesObj.quantity) * parseFloat((this.arLinesObj.unitprice || 0));
        this.calcTaxes();
    },
    calcTaxes : function() {
        this.arLinesObj.nilainett = this.arLinesObj.nilai - this.arLinesObj.nilaidisc;
        this.arLinesObj.dpp = parseFloat(this.arLinesObj.nilainett) * parseFloat(this.arLinesObj.dppnlain) / 100;
        this.arLinesObj.ppn = this.arLinesObj.ppn || 10;
        if (this.arLinesObj.kenappn == 1) {
            this.model.grossup = 0;
            this.arLinesObj.nilaippn = (parseFloat(this.arLinesObj.ppn,0)/100) * this.arLinesObj.dpp;
        } else {
            // this.arLinesObj.dpp = 0;
            // this.arLinesObj.ppn = 10;
            this.arLinesObj.nilaippn = 0;
        }
        if (this.model.grossup == 1)
            this.arLinesObj.dpp = this.arLinesObj.dpp * (100 / (100 - this.arLinesObj.pph));

        this.arLinesObj.nilaidue = this.arLinesObj.nilainett + this.arLinesObj.nilaippn;
        if (this.calcPPh == 1)
            this.arLinesObj.nilaipph = this.arLinesObj.dpp * this.arLinesObj.pph / 100;
        
        this.$forceUpdate();
    },
    onSelectLkuCustomer: async function (_selected) {
        this.model.custinfo = _selected.CustName.trim()+ ' | '+_selected.CustCode.trim();
        this.model.custcode = _selected.CustCode;
        this.model.customer_id = _selected.customer_id;
        // const dim = this.dimension.find(d => d.RelatedObj=='customer');
        // if (dim) {
        //     this.model[`${dim.value}`] = _selected.CustCode;
        //     this.model[`${dim.value}Txt`] = _selected.CustName.trim();
        //     this.model[`${dim.value}Info`] = _selected.CustName.trim()+ ' | '+_selected.CustCode.trim();
        // }
        this.lkuCustomerShow=false;
      this.tblData.pemasang = _selected.CustName.trim()+ ' | '+_selected.CustCode.trim();
      this.tblData.customer_id = _selected.customer_id;
      this.tblData.customer_name = _selected.CustName.trim();
      this.lkuCustomerShow=false;
    },    

    data: async function(ctx) {
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.KoranOpi) {
            this.tblData[key] = filter.KoranOpi[key];
            filtered=true;
        }
        if (filtered === true) {
          this.tblData.tgl1=filter.KoranOpi.tgl1 || '';
          this.tblData.tgl2=filter.KoranOpi.tgl2 || '';
          this.showFilter=filtered;
          delete filter.KoranOpi;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.isLoading=true;
      const list = await opi.invoicing(this.tblData);   
      this.isLoading=false;

      return list;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.juduliklan=  '';
        this.tblData.orderno=  '';
        this.tblData.proforma=  '';
        this.tblData.customer_id=  '';
        this.tblData.pemasang=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.isinvoiced=  '';
        this.tblData.completed=  '';
        this.tblData.salesae_id='';
        this.tblData.salesae_name='';
    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    rowEdit(record) {
      this.terpilih = record;
      this.edit();
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.print();        
    },
    rowPrintInvoice(record) {
      this.rowClicked(record);
        this.printInvoice();        
    },
    
    edit: async function() {
        if (this.terpilih.orderid) {
            toastr.info('Loading Generate Invoice data');
            if (this.terpilih.arinvKey)  {
                toastr.info('Loading ARDetail, please wait')
                try {
                  // const data = await Promise.all([arinv.postgroup(),arinv.pasalpph(),arinv.currency(),arinv.salesAccount(),arinv.bankacconly(),arinv.paymentform(),arinv.detail(this.terpilih)]) ;
                  // this.postGroups = a;
                  // this.lookupPPH = b;
                  // this.currency = c;
                  // this.salesAccounts = d;
                  // this.bankAccount = e;
                  // this.paymentForms = f;
                  const data = await arinv.detail(this.terpilih);  
                  const row = data[0][0];
                      this.saveEnabled=(row.posting === 0);
                      row.invdate = row.invdate ? moment(row.invdate).format('YYYY-MM-DD') : '';
                      row.invdueda = row.invdueda ? moment(row.invduedate).format('YYYY-MM-DD') : '';
                      row.tglfaktur = row.tglfaktur ? moment(row.tglfaktur).format('YYYY-MM-DD') : '';
                      for (var key in row) {
                          this.model[key] = row[key];
                      }
                      this.arLines.items = data[1];
                      this.arLines.total = this.arLines.items.length;
                  if ((row.issuenote=='CANCELATION') || (row.issuenote=='REISSUE')) {
                      toastr.error('Edit for this record only avlaible form menu "AR Invoice - Revision/Menu"');
                      this.saveEnabled=false;
                  } 
                      this.calcTotalDtl();
                      // this.tanggalBerubah();
                      // this.updateDimHdr = !this.updateDimHdr;            
                      toastr.clear;
                } catch (error) {
                      console.log('error : ', error);
                      toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
                }
            } else {            
              this.model.salesDtlKey=this.terpilih.salesDtlKey;
              this.model.order_id=this.terpilih.salesHdrKey;
              this.model.ordernumber = this.terpilih.mediaorder || this.terpilih.orderno;
              this.model.matauang=this.terpilih.matauang;
              this.model.pack_name=this.terpilih.jenisbayar || this.model.pack_name;
              this.model.keteranganbayar=this.terpilih.keteranganbayar;
              this.model.custinfo = this.terpilih.custinfo;
              this.model.customer_id = this.terpilih.customer_id;
              this.model.customer_name = this.terpilih.CustName.trim();
              this.model.custcode = this.terpilih.CustCode;        
              this.model.uraian1=this.terpilih.juduliklan;
              this.model.uraian2=this.terpilih.Advertiser;
              this.model.kontrakprd=this.terpilih.orderno;

              this.model.Advertiser=this.terpilih.Advertiser;
              this.model.brand=this.terpilih.brand;
              this.model.kategori=this.terpilih.kategori;
              this.model.accexec=this.terpilih.salesae_name | this.terpilih.SalesEx;
              this.model.salesae_id=this.terpilih.salesae_id || this.terpilih.SalesExCode;
                this.arLines.items.push({
                                arinvdtKey:'', 
                                unitsize:'', 
                                DimTableKey:'', 
                                salesDtlKey:'',
                                salesKode: 'N/A',
                                itemno:'N/A',
                                NamaSale: '',
                                description:this.terpilih.juduliklan,
                                unitprice: 0
                });

              let obj={};
              obj.arinvdtKey=''; 
              obj.unitsize=this.terpilih.unitsize || 'SPOT'; 
              obj.DimTableKey=''; 
              obj.salesDtlKey=this.terpilih.salesDtlKey;
              obj.salesKode= this.terpilih.itemno;
              obj.itemno=this.terpilih.saleCrCode;
              obj.NamaSale= this.terpilih.itemname || this.terpilih.saleCrName;

              obj.description= this.terpilih.description || `${this.terpilih.jiklan} ${this.terpilih.jwarna}`;
              obj.quantity= this.terpilih.jmlspot;
              obj.unitprice= this.terpilih.price;
              obj.nilai= this.terpilih.gross;
              obj.nilaippn= this.terpilih.ppn;
              obj.ppn= (this.terpilih.ppn) ? 10: 0
              obj.kenappn = (this.terpilih.ppn) ? 1: 0
              obj.nilaidisc=this.terpilih.diskon;
              obj.disc=this.terpilih.diskonpc;        
              obj.dppnlain = 100;
              obj.nilaipph = 0;
              obj.nilainett =this.terpilih.netto;
              obj.nilaidue= this.terpilih.totaliklan
              if (!(this.terpilih.itemname)) {
                const salesAccount = this.salesAccounts.find(s => ((s.value==this.terpilih.itemno) || (s.text.includes('DIGITAL'))));
                if (salesAccount) {
                    obj.NamaSale=salesAccount.text;
                    obj.itemno=salesAccount.saleCrCode;
                    obj.salesKode= salesAccount.value;
                }
              }
              this.arLines.items.push(obj);
              if ((this.terpilih.revlain) && (this.terpilih.revlaindesc)){
                obj={};
                obj.arinvdtKey=''; 
                obj.unitsize=''; 
                obj.DimTableKey=''; 
                obj.salesDtlKey=this.terpilih.salesDtlKey;
                obj.salesKode= this.terpilih.itemno;
                obj.description= this.terpilih.revlaindesc;
                obj.quantity= 1;
                obj.unitprice= this.terpilih.revlain;
                obj.nilai= this.terpilih.revlain;
                obj.nilaippn= 0;
                obj.ppn= 0
                obj.kenappn = 0
                obj.nilaidisc=0;
                obj.disc=0;        
                obj.dppnlain = 100;
                obj.nilaipph = 0;
                obj.nilainett =this.terpilih.revlain;
                obj.nilaidue= this.terpilih.revlain
                this.arLines.items.push(obj);
              }

              this.calcTotalDtl();
            }
            this.showForm=true;
        } else {
            toastr.warn('Please select a row that want to be processed!');
        }
    },
    rowClicked(record, index) {
        if ((this.terpilih) && (this.terpilih._rowVariant)) {
            delete this.terpilih._rowVariant;
        }
        this.terpilih = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
    },
    print: async function()
    {
      if (this.terpilih.orderid) {
          try {
                this.showReport=true;
              this.reportUrl = await opi.print({ orderid: this.terpilih.orderid});
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
              // console.log(error);
          }
        } else {
           this.isLoading=false;
            toastr.warn('Please select a row that want to be Printed or Generate Invoice!');
        }
    },

    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await opi.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    close(){
         router.push({name: "iklankoran.home"});
    },
    closeArLines: function(){
        const opened= this.arLines.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addArLines : function () {
        this.closeArLines();
        this.tabIndex=0;
        const obj={_showDetails:true};
        this.arLines.selected = obj;
        // for (var key in this.arLinesObj) {
        //     this.arLinesObj[key] = '';
        // }
        this.arLinesObj.arinvdtKey=''; 
        this.arLinesObj.unitsize=''; 
        this.arLinesObj.DimTableKey=''; 
        this.arLinesObj.salesKode= '';
        this.arLinesObj.description= '';
        this.arLinesObj.quantity= 1;
        this.arLinesObj.unitprice= 0;
        this.arLinesObj.nilai= 0;
        this.arLinesObj.ppn= 10;
        this.arLinesObj.nilaidisc=0;
        this.arLinesObj.disc=0;        
        this.arLinesObj.unitsize='EACH';
        this.arLinesObj.quantity = 1;
        this.arLinesObj.unitprice=0;
        this.arLinesObj.dppnlain = 100;
        this.arLinesObj.ppn = 10;
        this.arLinesObj.nilaipph = 0;
        this.arLinesObj.nilainett =0;
        this.calcPPh=1;
        this.updateDimHdr2Dtl(this.arLinesObj);
        this.arLines.items.push(obj);
        this.arLines.total=this.arLines.items.length;
        setTimeout(() => {
                const bfore = this.arLines.page;
                const after =Math.ceil((this.arLines.total)/this.arLines.limit);
                if (bfore != after){
                    this.arLines.page =  after;                 
                    toastr.info(`Move to page ${after} of total  ${this.arLines.total} items`,'Line/Detail',10000);
                }
        }, 100);    
        this.inputLineBerlanjut=1;
    },
    editArLines : function (obj,callback) {
        this.closeArLines();
        this.arLines.selected = obj;
        // for (var key in this.arLinesObj) {
        //     this.arLinesObj[key] = '';
        // }
            this.arLinesObj.unitsize=''; 
            this.arLinesObj.DimTableKey=''; 
            this.arLinesObj.salesKode= '';
            this.arLinesObj.description= '';
            this.arLinesObj.quantity= 1;
            this.arLinesObj.unitprice= 0;
            this.arLinesObj.nilai= 0;
            this.arLinesObj.ppn= 10;
            this.arLinesObj.kenappn= 0;
            this.arLinesObj.pasalpph= '';
            this.arLinesObj.pph= 0;
            this.arLinesObj.nilaidisc=0;
            this.arLinesObj.disc=0;        
        for (var key in obj) {
            this.arLinesObj[key] = obj[key];
        }

        // this.dimension.forEach((dim) => {
        //     if (obj[dim.value]) {
        //         this.arLinesObj[dim.value] = obj[dim.value];
        //         this.arLinesObj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
        //         this.arLinesObj[`${dim.value}Info`] = obj[dim.value] + ' | '+ obj[`${dim.value}Txt`];
        //     }
        // });
        this.tabIndex=0;
        this.inputLineBerlanjut=0;
        callback();
    },
    delArLines: function (index) {
        if (index > -1) {
            // this.arLines.items.splice(index, 1);
            const posisi = (this.arLines.page-1)*this.arLines.limit;
            this.arLines.items.splice(posisi+index, 1);
        }
        this.arLines.total=this.arLines.items.length;
        this.calcTotalDtl();
    },
    saveArLines: async function (callback) {
        this.arLinesObj.pasalpph= this.arLinesObj.pasalpph || 'N/A';
        this.calcPrice();
        if (this.invalidArLines) {
            const invalidobj={};
            for (var key in this.$v.arLinesObj) {
            if (this.$v.arLinesObj[key].$anyError) {
                if (this.$v.arLinesObj[key].$anyError==true) invalidobj[key] = this.$v.arLinesObj[key];
            }
            }        
            console.log('validation model: ', this.arLinesObj);
            console.log('validation field: ', invalidobj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
       } else {
           if (this.tabIndex==0) {
                for (var key in this.arLinesObj) {
                    this.arLines.selected[key] = this.arLinesObj[key];
                }
                this.calcTotalDtl();
               this.tabIndex=1;
               return
           }
            let datadim=this.arLinesObj;
            datadim.TableName = 'arinvdt';
            try {
                // const dimValResult = await dimension.validate(datadim);
                // if (dimValResult.success) {
                    for (var key in this.arLinesObj) {
                        this.arLines.selected[key] = this.arLinesObj[key];
                    }
                    this.arLines.selected.calcPPh= this.calcPPh;
                    // this.dimension.forEach((dim) => {
                    //     if (datadim[dim.value]) {
                    //         this.arLines.selected[dim.value] = datadim[dim.value];
                    //         this.arLines.selected[`${dim.value}Txt`] = datadim[`${dim.value}Txt`];
                    //     }
                    // });
                    this.arLines.total=this.arLines.items.length;
                    // this.updateDimDtl2Hdr(datadim);
                    this.calcTotalDtl();
                    this.arLines.selected._showDetails=false;
                    if (callback) callback();
                // if (this.inputLineBerlanjut==1) {
                //     this.addArLines();
                //     this.$v.arLinesObj.$reset();
                // }

                // } else {
                //     console.log('dimValResult : ', dimValResult);
                //     var msg = dimValResult.message;
                //     if (callback) callback(new Error(msg));
                //     else {
                //         toastr.error(msg, "ERROR MESSAGE",10000);
                //     }
                // }
            } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
            }
        }
    },
    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.isLoading=true;            
        if (((this.model.ttlvat || 0) !== 0) && ((this.model.nofaktur || '')=='')) {
            toastr.info('[No.Faktur Pajak] akan diisi otomatis jika NSFP(E-NoFa) sudah diisi', "Modul TAX Admin",10000);
        } 

        if (this.invalidModel) {
            const invalidobj={};
            for (var key in this.$v.model) {
            if (this.$v.model[key].$anyError) {
                if (this.$v.model[key].$anyError==true) invalidobj[key] = this.$v.model[key];
            }
            }        
            console.log('validation model: ', this.model);
            console.log('validation field: ', invalidobj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.isLoading=false;  
            
        } else if (this.arLines.items.find(line => (line.nilai) && (!(line.salesKode)) ))  {
            toastr.error('Please fill [REVENUE ACCOUNT] in Line/detail Invoice', "ERROR MESSAGE",10000);
            this.isLoading=false;                        
        } else if (Math.abs(this.model.totalinv - parseFloat(this.model.ttlamtdue))>0.5)  {
            toastr.error('[Total Invoice] not Balance with [Total Detail Invoice]', "ERROR MESSAGE",10000);
            this.isLoading=false;            
        } else {
            try {
                this.model.TableName = 'arinvtt';
                // const dimValResult = await dimension.validate(this.model);
                // if (dimValResult.success) {
                    // this.model.DimTableKey = diisi dari PO;
                    this.model.arinvKey = this.model.arinvKey || '';
                    this.model.invoiceno = this.model.invoiceno || '';
                    const row = {};
                    for (var key in this.model) {
                        row[key] = this.model[key];
                    }
                    row.invdate = moment(row.invdate).format('YYYY-MM-DD');
                    row.invdueda = (row.invdueda) ? moment(row.invdueda).format('YYYY-MM-DD'):row.invdate ;
                    row.tglfaktur = row.tglfaktur ? moment(row.tglfaktur).format('YYYY-MM-DD') : undefined;
                    
                    let lineno=1;
                    let newArLines = this.arLines.items.reduce((newArr, item) => {
                        if ((item.salesKode || '') != '') {
                            item.lineno = lineno;
                            newArr.push(item);
                            lineno += 1;
                        }
                        return newArr;
                    }, []);

                    row.lines = newArLines;
                    const hasil= await arinv.insert(row);
                    toastr.success(`Success, Trx.Number ${hasil.invoiceno}`, "Save AR Invoice",10000);

                    if (this.inputBerlanjut==0){
                        hasil.orderid= this.terpilih.orderid;
                        opi.invoicingsuccess(hasil).then(result=>{
                          console.log('update OPI invoicing success -> ', result);
                        }).catch(err => {
                          console.log('update OPI invoicing  -> ', err);
                       });
                        this.showForm=false;
                    } else {
                        this.isLoading=false;            
                        const invdate = this.model.invdate;
                        for (var key in this.model) {
                            this.model[key] = '';
                        }
                        this.model.invdate = invdate;
                        this.model.matauang= this.$store.state.user.matauang;
                        // this.model.invdate = moment().format('YYYY-MM-DD');
                        this.arLines.items = [];
                        this.arLines.total=0;
                        this.calcTotalDtl();
                        this.$v.model.$reset();
                    }

                // } else {
                //     this.isLoading=false;            
                //     console.log('dimValResult : ', dimValResult);
                //     var msg = dimValResult.message || 'Dimension validation error';
                //     toastr.error(msg, "ERROR MESSAGE",10000);
                // }

            } catch (error) {
                this.isLoading=false;            
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
            }

        }
    },
    updateDimDtl2Hdr: function (dimDtl) {
        var dimHdr = this.model;
        this.dimension.forEach((dim) => {
            if ((dimDtl[dim.value]) && !(dimHdr[dim.value])) {
                dimHdr[dim.value] = dimDtl[dim.value];
                dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
                dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`] ;
            }
        });
        this.updateDimHdr = !this.updateDimHdr;
    },
    updateDimHdr2Dtl: function (dimDtl) {
        var dimHdr = this.model;
        dimDtl = dimDtl || this.arLinesObj;
        this.dimension.forEach((dim) => {
            if ((dimHdr[dim.value]) && !(dimDtl[dim.value])) {
                dimDtl[dim.value] = dimHdr[dim.value];
                dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
                dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`] ;
            }
        });
        this.updateDimDtl = !this.updateDimDtl;
    },
    calcTotalDtl: function () {
        // this.model.calcVAT = this.model.calcVAT || 1;
        // this.model.calcDisc = this.model.calcDisc || 1;
        let nilaidpp = 0;
        let ttlvat = 0;
        let ttlgross = 0;
        let ttldiskon = 0;
        // let ttlamtdue = 0;
        let totalpph = 0;
        let totaldpp = 0;
        this.arLines.items.forEach( function (trx) {
            if (trx.salesKode) {
                nilaidpp += (trx.dpp || 0);
                ttlgross += (trx.nilai || 0);
                ttldiskon += (trx.nilaidisc || 0);
                ttlvat += (trx.nilaippn || 0);
                // ttlamtdue = ttlnetto + (nilaippn || 0);
                totalpph += parseFloat(trx.nilaipph || 0);
            }
        });
        this.model.ttlgross = ttlgross;
        if (this.model.calcVAT == 1){
            this.model.nilaidpp = nilaidpp;
            this.model.ttlvat = ttlvat;
        }
        if (this.model.calcDisc == 1){
            this.model.ttldiskon = ttldiskon;
        }
        this.model.ttlnetto =this.model.ttlgross-this.model.ttldiskon;
        this.model.ttlamtdue = this.model.ttlnetto+this.model.ttlvat;
        this.model.totalinv = this.model.ttlamtdue ;
        this.model.totalpph = totalpph;
    },
    printInvoice: async function()
    {
      if (this.terpilih.arinvKey) {
          try {
                this.showReport=true;
              this.isprintjv=false;
              this.reportUrl= await arinv.print(this.terpilih);
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },    
  }
};
</script>
